export default "__VITE_ASSET__5PSWkwAQ__"